import React, { Component } from 'react';

export default class NotConsultable extends Component {
  render() {

    return (
      <div id="kakaoContent" className="cont_bridge" role="main">
        <span className="img_404" />
        <strong className="tit_bridge">채팅이 불가능한 프로필입니다.</strong>
        <p className="desc_bridge">해당 채널은 더 이상 채팅 기능을 <br/>사용하지 않습니다.</p>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ErrorContent/NotConsultable.js